import { Button, ButtonProps, Text } from "@mantine/core"
import React from "react"
import classes from "./segmented-chip.module.css"

type FilterChipProps = ButtonProps & {
  active: boolean
  count?: number
  onClick: () => void
  children: React.ReactNode
}

/** Filter chip (one concept with de-network-admin): pill, active = dark.8 background + white text, count in gray.7. */
export function FilterChip({ active, count, onClick, children, ...rest }: Readonly<FilterChipProps>) {
  return (
    <Button
      {...rest}
      radius="xl"
      variant={active ? "filled" : "default"}
      color={active ? "dark.8" : undefined}
      className={classes.chip}
      data-active={active || undefined}
      aria-pressed={active}
      onClick={onClick}>
      {children}
      {typeof count === "number" && (
        <Text span fz={14} fw={500} ml={6} c={active ? undefined : "gray.7"}>
          {count}
        </Text>
      )}
    </Button>
  )
}
